<template>
    <div>
        <el-dialog
            class="box"
            :visible.sync="registerDialog"
            :close-on-click-modal="false"
            width="30%"
            min-width="500px"
            :before-close="handleClose"
        >
            <div
                class="ms-title"
                style="font-size: 14px; color: #666; margin-bottom: 40px; cursor: pointer; display: flex; justify-content: center"
            >
                <span
                    :class="{ selected: selectStyle == 1 }"
                    @click="selectStyle = 1"
                    style="min-width: 100px;font-size: 16px; text-align: center; font-weight:bold;border-bottom: #fff solid 4px; padding-bottom: 9px"
                    >个人注册</span
                >
                <span
                    :class="{ selected: selectStyle == 2 }"
                    @click="selectStyle = 2"
                    style="min-width: 100px; font-size: 16px;text-align: center;
                    font-weight:bold;margin-left: 20px; border-bottom: #fff solid 4px; padding-bottom: 9px"
                    >企业注册</span
                >
            </div>
            <!-- 个人注册 -->
            <div v-show="selectStyle == 1">
                <el-form :model="registerForm" :rules="rules" ref="registerForm" label-width="0px" class="ms-content">
                    <el-form-item prop="username">
                        <el-input v-model="registerForm.username" placeholder="请输入与身份证一致的姓名">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="cardid">
                        <el-input v-model="registerForm.cardid" placeholder="请输入真实的身份证号码">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg cardImg"></el-button>
                        </el-input>
                    </el-form-item>
                    <!--                    <el-form-item prop="addressId">-->
                    <!--                        <el-select v-model="registerForm.addressId" placeholder="请选择工作单位州市">-->
                    <!--                            <el-option v-for="(item, index) of addressId" :key="index" :label="item" :value="index"></el-option>-->
                    <!--                        </el-select>-->
                    <!--                    </el-form-item>-->
                    <el-form-item prop="bookLevel">
                        <el-select v-model="registerForm.bookLevel" placeholder="请选择自己的身份">
                            <el-option v-for="(item, index) in bookLevel" :key="index" :label="item" :value="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="mobile">
                        <!-- <div  @click="getCode()">{{ code_text }}</div> -->
                        <!--                        <SmsSend class="getCode" :mobile="loginForm.mobile" smsType="register"></SmsSend>-->
                        <el-input v-model="registerForm.mobile" placeholder="请输入手机号">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg mobile"></el-button>
                        </el-input>
                    </el-form-item>
                    <!-- 这里差 对应接口的短信验证码-->
                    <el-form-item prop="code" style="position: relative">
                        <el-input v-model="registerForm.code" placeholder="请输入短信验证码">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg code"></el-button>
                            <el-link class="getCode" @click="getCode" slot="append" type="primary" :disabled="disabled">
                                {{ code_text }}
                            </el-link>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" placeholder="请设置密码" v-model="registerForm.password">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg psw"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="passwordA">
                        <el-input type="password" placeholder="请再次输入密码" v-model="registerForm.passwordA">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg psw2"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="login-btn">
                    <el-button type="primary" @click="submit">立即注册</el-button>
                </div>
            </div>
            <!-- 企业登录 -->
            <div v-show="selectStyle == 2">
                <el-form :model="registerForm2" :rules="rules2" ref="registerForm2" label-width="0px" class="ms-content">
                    <el-form-item prop="code">
                        <el-input v-model="registerForm2.code" placeholder="请输入统一社会信用代码">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="name">
                        <el-input v-model="registerForm2.name" placeholder="请输入企业名称">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="addressId">
                        <el-select v-model="registerForm2.addressId" placeholder="请选择工作单位州市">
                            <el-option v-for="(item, index) of addressId" :key="index" :label="item" :value="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="username">
                        <el-input v-model="registerForm2.username" placeholder="请输入企业联系人">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="mobile">
                        <el-input v-model="registerForm2.mobile" placeholder="请输入企业联系人电话">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg mobile"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" placeholder="请输入密码" v-model="registerForm2.password">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg psw"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="passwordA">
                        <el-input type="password" placeholder="请再次输入密码" v-model="registerForm2.passwordA">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg psw2"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="login-btn">
                    <el-button type="primary" @click="enterSubmit">立即注册</el-button>
                </div>
            </div>
            <!--            <div class="login-btn">-->
            <!--                <el-button type="primary">注册</el-button>-->
            <!--            </div>-->
        </el-dialog>
    </div>
</template>

<script>
import bm from '@/api/bm';
import user from '@/api/user';

export default {
    props: {
        registerDialog: { type: Boolean, default: false }
    },
    data: function() {
        const validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.registerForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        const validatePass3 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.registerForm2.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            code_text: '获取验证码',
            time: 0,
            disabled: false,
            selectStyle: 1,
            sms: {
                mobile: '',
                event: 'register'
            },
            registerForm: {},
            registerForm2: {},
            rules: {
                username: [{ required: true, message: '请输入与身份证一致的姓名', trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    {
                        min: 6,
                        max: 20,
                        message: '密码长度在6-20位之间',
                        trigger: ['blur', 'change']
                    }
                ],
                passwordA: [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { validator: validatePass2, trigger: ['blur', 'change'] }
                ],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1\d{10}$/, message: '手机号格式不对', trigger: 'blur' }
                ],
                cardid: [{ required: true, message: '请输入真实的身份证号码', trigger: 'blur' }],
                code: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
                addressId: [{ required: true, message: '请选择工作单位州市', trigger: 'blur' }],
                bookLevel: [{ required: true, message: '请选择自己的身份', trigger: 'blur' }]
            },
            rules2: {
                username: [{ required: true, message: '请输入企业联系人', trigger: 'blur' }],
                name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
                code: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
                mobile: [
                    { required: true, message: '请输入企业联系人电话', trigger: 'blur' },
                    { pattern: /^1\d{10}$/, message: '手机号格式不对', trigger: 'blur' }
                ],
                addressId: [{ required: true, message: '请选择工作单位州市', trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    {
                        min: 6,
                        max: 20,
                        message: '密码长度在6-20位之间',
                        trigger: ['blur', 'change']
                    }
                ],
                passwordA: [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { validator: validatePass3, trigger: ['blur', 'change'] }
                ]
            },
            addressId: [],
            bookLevel: []
        };
    },
    watch: {
        selectStyle(val) {
            console.log(val);
            if (this.$refs.registerForm2) {
                this.registerForm2 = {};
                this.$refs.registerForm2.resetFields();
                this.$refs.registerForm2.clearValidate();
                console.log(222);
            }
            if (this.$refs.registerForm) {
                this.registerForm = {};
                this.$refs.registerForm.resetFields();
                this.$refs.registerForm.clearValidate();
                console.log(333);
            }
        }
    },
    created() {
        this.getBaseinfo();
    },
    methods: {
        getCode() {
            if (this.time > 0) {
                return false;
            }
            this.sms.mobile = this.registerForm.mobile;
            let valid = this.$refs.registerForm.validateField('mobile', mobileErr => {
                console.log(mobileErr);
                if (!mobileErr) {
                    user.get_code(this.sms)
                        .then(res => {
                            if (res.code == 1) {
                                this.$message.success(`验证码发送成功`);
                                //成功后改为倒计时60s
                                this.code_text = '60秒后重试';
                                this.validateBtn();
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                        .catch(error => {
                            this.$message.error(error.msg);
                            this.btnLoading = false;
                        });
                } else {
                    this.$message.error('请输入正确的手机号');
                    return false;
                }
            });
        },
        validateBtn() {
            //倒计时
            this.time = 59;
            let timer = setInterval(() => {
                if (this.time == 0) {
                    clearInterval(timer);
                    this.code_text = '获取验证码';
                    this.disabled = false;
                } else {
                    this.code_text = this.time + '秒后重试';
                    this.disabled = true;
                    this.time--;
                }
            }, 1000);
        },
        getBaseinfo() {
            bm.baseinfo()
                .then(res => {
                    this.bookLevel = res.data.bookLevel;
                    this.addressId = res.data.addressId;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        handleClose() {
            // 关闭弹窗
            this.registerForm = {};
            this.registerForm2 = {};
            // if (this.selectStyle == 1) {
            //     this.$refs.registerForm.resetFields();
            // } else {
            //     this.$refs.registerForm2.resetFields();
            // }
            this.$emit('update:registerDialog', false);
        },
        // 个人注册
        submit() {
            console.log(this.registerForm);
            let new_form = Object.assign({}, this.registerForm);
            this.$delete(new_form, 'passwordA');
            this.$refs.registerForm.validate(valid => {
                if (valid) {
                    user.register(new_form)
                        .then(res => {
                            this.$message.success(`注册成功`);
                            console.log(res);
                            location.href = 'http://tsm.ynbzde.com/#/dashboard/train/index?token=' + res.data.ertoken;
                            //成功后改为倒计时60s
                        })
                        .catch(err => {
                            if ([0, 2].includes(err.code * 1)) {
                                this.$message.error(err.msg);
                            } else if (typeof err == 'string') {
                                this.$message.error(err);
                            } else {
                                this.$message.error('发生异常情况， 请联系管理人员');
                                console.log(err);
                            }
                        });
                }
            });
        },
        // 企业注册
        enterSubmit() {
            let new_form = Object.assign({}, this.registerForm2);
            console.log(new_form);
            // return false;
            this.$delete(new_form, 'passwordA');

            this.$refs.registerForm2.validate(valid => {
                if (valid) {
                    user.enterpriseRegister({ row: new_form })
                        .then(res => {
                            this.$message.success(`企业注册成功`);
                            // console.log(res);
                            this.$emit('update:registerDialog', false);
                            let data = res.data.userinfo;
                            this.$store.dispatch('set_enter', data);
                            this.$router.push('/home/company');
                        })
                        .catch(err => {
                            if (err.code == 0) {
                                this.$message.error(err.msg);
                            } else if (typeof err == 'string') {
                                this.$message.error(err);
                            } else {
                                this.$message.error('发生异常情况， 请联系管理人员');
                                console.log(err);
                            }
                        });
                }
            });
            console.log('企业注册');
        }
    }
};
</script>

<style lang="less" scoped>
.box {
    .selected {
        color: #1890ff;
        border-bottom: solid 1px #1890ff !important;
    }

    /deep/ .el-button--small,
    .el-button--small.is-round {
        padding: 9px 15px;
        width: 100%;
    }

    /deep/ .el-select {
        width: 100%;
        margin-bottom: 15px;
    }
    /deep/ .el-form-item__content {
        height: 35px;
    }
    /deep/ .el-dialog {
        min-width: 500px;
    }
    .getCode {
        position: absolute;
        border: 1px solid rgba(32, 53, 128, 0.16078431372549018);
        background: linear-gradient(302deg, #007ee5 0%, #05a0ff 100%, #5533ff 100%);
        padding: 0 10px;
        min-width: 100px;
        height: 32px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        right: 0px;
        top: 0px;
        z-index: 99;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        cursor: pointer;
        color: #fff;
        font-size: 12px;
    }
    .key_img {
        background-image: url('~@/assets/img/loginkey.png');
    }
    .mobile {
        background-image: url('~@/assets/img/iphone.png');
    }
    .code {
        background-image: url('~@/assets/img/code.png');
    }
    .psw {
        background-image: url('~@/assets/img/psw.png');
    }
    .psw2 {
        background-image: url('~@/assets/img/psw2.png');
    }
    .headImg {
        width: 5px;
        height: 5px;
        background-repeat: no-repeat;
        position: absolute;
        left: 33px;
        top: 17px;
    }
}
</style>
